@for (e of events; track e.id) {
  <article class="fs-ev overflow-auto">
    <header class="fs-ev__top">
      <div class="fs-ev__left">
        <div class="fs-ev__title">{{ auditFriendlyName(e.actionName) }}</div>
        <app-badge
          [type]="e.success ? 'success' : 'danger'"
        >
          {{ e.success ? 'Sucesso' : 'Erro' }}
        </app-badge>
      </div>

      <time class="fs-ev__time">{{ e.startTime | date: 'short' }}</time>
    </header>

    <div class="fs-ev__grid h-auto">
      <div class="fs-ev__cell">
        <span class="fs-ev__k">Usuário:</span>
        <span class="fs-ev__v">{{ e.userName }} (ID: {{ e.userId }})</span>
      </div>

      <div class="fs-ev__cell">
        <span class="fs-ev__k">IP:</span>
        <span class="fs-ev__v fs-ev__mono">{{ e.ipAddress }}</span>
      </div>

      <div class="fs-ev__cell">
        <span class="fs-ev__k">Trace ID:</span>
        <span class="fs-ev__v fs-ev__mono">{{ e.traceId }}</span>
      </div>

      <div class="fs-ev__cell">
        <span class="fs-ev__k">Duração:</span>
        <span class="fs-ev__v">{{ formatElapsed(e.elapsedSeconds) }}</span>
      </div>
    </div>
  </article>
} @empty {
  <div class="fs-ev__empty">Nenhum evento encontrado.</div>
}
